"use client";

import React from "react";

import CarouselSection, { ICarouselItem } from "src/lib/components/banner-section/footmart";
import { toAssetImages } from "src/lib/utils";
import Sidebar from "./footmart/sidebar";

export interface VariantProps {
  carouselData?: Array<ICarouselItem>;
  categoryList?: Array<{
    id: string;
    code: string; // TODO: query top sale
    imgUrl: string;
    name: string;
  }>;
  offers: {
    left: {
      title?: { text: string; color: string };
      subTitle?: { text: string; color: string };
      bgImg?: string;
    };
    right: {
      title?: { text: string; color: string };
      subTitle?: { text: string; color: string };
      bgImg?: string;
    };
  };
}

const CategorySectionBazaar: React.FC<VariantProps> = ({
  carouselData,
  categoryList,
}: VariantProps) => {
  return (
    <div
      style={{ backgroundImage: `url(${toAssetImages("misc/footmart-bg-category-section.jpg")})` }}
    >
      <Sidebar categoryList={categoryList}>
        <CarouselSection carouselData={carouselData || []} linkTo={"/collection"} mobileImgOff />
      </Sidebar>
    </div>
  );
};

export default CategorySectionBazaar;
